import { Outlet, useLocation } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

// 푸터를 숨길 전체화면 페이지 경로
const FULLSCREEN_PATHS = ['/ai-chat'];

export default function RootLayout() {
  const { pathname } = useLocation();
  const hideFooter = FULLSCREEN_PATHS.includes(pathname);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}
